import { Component } from "react";
import {
    withRouter
} from 'react-router-dom';
import {
    BlockStack,
    Modal,
    TextField,
    Checkbox,
    Banner,
    Select,
    RadioButton,
    Tooltip,
    Button,
    Text,
    Icon,

} from "@shopify/polaris";
import { DuplicateMinor, LinkMinor } from '@shopify/polaris-icons';
import "./index.css";
import Language from "../../i18n/Language";
import { reqReviewTipsClick, reqSaveSwitchState } from "../../api";
import ToastFunc from "../ToastFunc";
import { store } from "../../redux/store";
import cloneDeep from 'lodash-es/cloneDeep';
import debounce from 'lodash-es/debounce';
import { connect } from 'react-redux'
import { setSaveSwitchData } from "../../redux/actions/getAppPublicData";
// 数量动画
import CountUp from 'react-countup';
import utils from "../../utils/utils";
const t = Language;

class TaskReward extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showToast: false,
            showToastText: false,
            showToastIserror: false,

            // 选择框value
            KeywordResearch: false,
            CompetitorAnalysis: false,
            WebsiteAudit: false,
            BacklinkAnalysis: false,
            RankingTracking: false,
            ContentOptimization: false,
            ImpoveWebsiteSpeed: false,
            ThirdOthers: false,
            Complex: false,
            DelayedDataUpdates: false,
            UserInterfaceUnfriendly: false,
            SlowCustomerServiceResponse: false,
            TooExpensive: false,
            FourOthers: false,
            FifthOthers: false,
            SixOthers: false,
            SEOChecker: false,
            Sitespeedup: false,
            ImageOptimization: false,
            OnPageSEO: false,
            MetaTags: false,
            ExchangeBacklink: false,
            CompetitorKeywordsResearch: false,
            SEOCheckerImprove: false,
            SitespeedupImprove: false,
            ImageOptimizationImprove: false,
            OnPageSEOImprove: false,
            MetaTagsImprove: false,
            ExchangeBacklinkImprove: false,
            CompetitorKeywordsResearchImprove: false,

            // 输入框value
            websiteVal: '',
            usedAppVal: '',
            ThirdOthersVal: '',
            FourOthersVal: '',
            recommendVal: '',
            FifthOthersVal: '',
            SixOthersVal: '',
            usedType: -1,
            improveSel: '',
            improveVal: '',
            describeVal: '',

            sendLoading: false,
            isShowWarnFeedback: '',
            isShowPlatformCol: false,

            postLinkOne: '',
            postLinkTwo: '',
            isFinishFirst: false,
            isFinishSec: false,
            firstError: "",
            secError: '',
            loadingPost: "",
            isFinishFeedbackSet: false, // 是否完成feedback
            isFinishPlatSet: false, // 是否完成平台分享
            platSetNum: 0, // 已设置数量
            switchData: this.props.switchData, // 公共数据
            quotaAll: this.props.quotaAll,
            isTaskFbLoading: false,
            isShowFBFinish: false, // 是否完成
            isShowPlatFinish: false,

            curImage: 0,    // 当前额度
            curAi: 0,
            ap_login_url: '',
            short_url: '',
            isShowFeedback: this.props.isShowFeedback,      // 弹窗状态
            isShowSharePlat: this.props.isShowSharePlat,
            verifyUrl: "",
            isFinishState: false,       // 是否完成
            verifyError: "",
            verifyLoading: false,
        }
    }

    componentDidMount() {
        // 设置任务
        this.setTaskQuota(this.props.quotaAll)
        this.setTaskData(this.props.switchData);
        let _aps = store.getState().public.publicInit?.other_options?.aps;
        let ap_login_url = _aps?.ap_login_url || '#';
        let short_url = _aps?.short_url || '#';
        this.setState({
            ap_login_url,
            short_url,
        })
    }

    shouldComponentUpdate(nextProps) {
        if (nextProps.isShowTask !== this.props.isShowTask) {
            this.setState({
                isShowModal: nextProps.isShowTask,
            })
        }

        if (nextProps.switchData !== this.props.switchData) {
            this.setState({
                switchData: nextProps.switchData,
            }, () => {
                this.setTaskData(nextProps.switchData);
            })
        }

        if (nextProps.quotaAll !== this.props.quotaAll) {
            this.setState({
                quotaAll: nextProps.quotaAll,
            }, () => {
                this.setTaskQuota(nextProps.quotaAll)
            })
        }

        if (nextProps.isShowFeedback !== this.props.isShowFeedback) {
            this.setState({
                isShowFeedback: nextProps.isShowFeedback,
            })
        }

        if (nextProps.isShowSharePlat !== this.props.isShowSharePlat) {
            this.setState({
                isShowSharePlat: nextProps.isShowSharePlat,
            })
        }

        return true;
    }


    // 设置额度
    setTaskQuota = (data) => {
        if (data) {
            this.setState({
                curImage: Number(data.images_all) + Number(data.img_usage_all),
                curAi: Number(data.points_gift_all) + Number(data.points_paid_all),
            })
        }
    }

    // 设置任务
    setTaskData = (data) => {
        if (data && data?.is_new_user_incentives) {
            let _t = data.is_new_user_incentives;
            let verifyUrl = _t?.share_platform?.postlink?.first || _t?.share_platform?.postlink?.sec || '';
            this.setState({
                verifyUrl,
                isFinishState: Boolean(Number(_t?.share_platform?.st) === 1),
            })
        }
    }

    // 打开对应程序
    openAppAction = (type) => {
        // 脸书
        if (type === 'facebook') {
            let url = `https://share.channelwill.com/app/11666a63547adbdrhz`;
            let iWidth = 650;
            let iHeight = 700;
            let iTop = (window.screen.availHeight - 30 - iHeight) / 2;
            let iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
            let targetUrl = `https://facebook.com/sharer/sharer.php?u=${url}`;
            window.open(targetUrl, 'about:blank', 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no');
        } else if (type === 'linkin') {
            const lkShare = encodeURIComponent('🚀Discover SEOAnt: A Comprehensive SEO Solution for Shopify Stores!✨\n- Provides speed optimization\n- Generates meta titles and meta descriptions\n- Supports backlink exchange\n- Utilizes AI to automatically generate SEO-compliant content\nClick the link now to enjoy a 30% discount!🎉\nhttps://share.channelwill.com/app/11666a63547adbdrhz\n#Shopify #SEO #ECommerce #AI');
            window.open(`https://www.linkedin.com/sharing/share-offsite/?text=${lkShare}`, '_blank');
        } else {
            const twShare = encodeURIComponent('🚀Discover SEOAnt: A comprehensive Shopify store SEO solution!✨\nIncrease website speed、Generate meta titles and meta descriptions、Competitive website analysis、More SEO features...\nClick the link now to enjoy 30% off!🎉\nhttps://share.channelwill.com/app/11666a63547adbdrhz\n#Shopify #SEO #Ecommerce #AI');
            window.open(`https://twitter.com/intent/tweet?text=${twShare}`, '_blank');
        }
    }

    // 输入
    handleChangeValue = (val, type) => {
        this.setState({
            [type]: val
        })
    }

    // 打开反馈
    openFeedback = () => {
        let { isFinishFeedbackSet } = this.state;
        if (!isFinishFeedbackSet) {
            this.setState({
                isShowModal: false,
                isShowFeedback: true,
            })
        } else {
            this.toggleToast(t("Completed"));
        }
    }

    // 关闭反馈
    closeFeedback = () => {
        this.setState({
            isShowModal: true,
            isShowFeedback: false,

            // 选择框value
            KeywordResearch: false,
            CompetitorAnalysis: false,
            WebsiteAudit: false,
            BacklinkAnalysis: false,
            RankingTracking: false,
            ContentOptimization: false,
            ImpoveWebsiteSpeed: false,
            Complex: false,
            DelayedDataUpdates: false,
            UserInterfaceUnfriendly: false,
            SlowCustomerServiceResponse: false,
            TooExpensive: false,
            SEOChecker: false,
            Sitespeedup: false,
            ImageOptimization: false,
            OnPageSEO: false,
            MetaTags: false,
            ExchangeBacklink: false,
            CompetitorKeywordsResearch: false,
            SEOCheckerImprove: false,
            SitespeedupImprove: false,
            ImageOptimizationImprove: false,
            OnPageSEOImprove: false,
            MetaTagsImprove: false,
            ExchangeBacklinkImprove: false,
            CompetitorKeywordsResearchImprove: false,
            ThirdOthers: false,
            FourOthers: false,
            FifthOthers: false,
            SixOthers: false,

            // 输入框value
            websiteVal: '',
            usedAppVal: '',
            ThirdOthersVal: '',
            FourOthersVal: '',
            FifthOthersVal: '',
            SixOthersVal: '',
            usedType: -1,
            improveSel: '',
            improveVal: '',
            describeVal: '',

            isShowWarnFeedback: '',
        }, () => {
            this.toggleTaskModal("isShowFeedback", false)
        })
    }

    // 保存反馈
    saveFeedback = () => {
        let {
            KeywordResearch,
            CompetitorAnalysis,
            WebsiteAudit,
            BacklinkAnalysis,
            RankingTracking,
            ContentOptimization,
            ImpoveWebsiteSpeed,
            Complex,
            DelayedDataUpdates,
            UserInterfaceUnfriendly,
            SlowCustomerServiceResponse,
            TooExpensive,
            SEOChecker,
            Sitespeedup,
            ImageOptimization,
            OnPageSEO,
            MetaTags,
            ExchangeBacklink,
            CompetitorKeywordsResearch,
            SEOCheckerImprove,
            SitespeedupImprove,
            ImageOptimizationImprove,
            OnPageSEOImprove,
            MetaTagsImprove,
            ExchangeBacklinkImprove,
            CompetitorKeywordsResearchImprove,
            ThirdOthers,
            FourOthers,
            FifthOthers,
            SixOthers,
            websiteVal,
            ThirdOthersVal,
            FourOthersVal,
            FifthOthersVal,
            SixOthersVal,
            usedType,
            usedAppVal,
            improveSel,
            improveVal,
            describeVal,

        } = this.state;
        // 参数
        let dataObj = {
            website: { state: true, value: websiteVal, field: 'website' },
            usedApp: { state: true, check: usedType, value: usedAppVal, field: 'usedApp' },
            purpose: {
                KeywordResearch: { state: KeywordResearch, field: "Keyword research" },
                CompetitorAnalysis: { state: CompetitorAnalysis, field: "Competitor analysis" },
                WebsiteAudit: { state: WebsiteAudit, field: "Website Audit" },
                BacklinkAnalysis: { state: BacklinkAnalysis, field: "Backlink analysis" },
                RankingTracking: { state: RankingTracking, field: "Ranking tracking" },
                ContentOptimization: { state: ContentOptimization, field: "Content optimization" },
                ImpoveWebsiteSpeed: { state: ImpoveWebsiteSpeed, field: "Impove website speed" },
                ThirdOthers: { state: ThirdOthers, field: "Others (please specify)", value: ThirdOthersVal },
            },
            valuable: {
                SEOChecker: { state: SEOChecker, field: "SEO Checker" },
                Sitespeedup: { state: Sitespeedup, field: "Site speed up" },
                ImageOptimization: { state: ImageOptimization, field: "Image Optimization" },
                OnPageSEO: { state: OnPageSEO, field: "On-Page SEO" },
                MetaTags: { state: MetaTags, field: "Meta Tags" },
                ExchangeBacklink: { state: ExchangeBacklink, field: "Exchange Backlink" },
                CompetitorKeywordsResearch: { state: CompetitorKeywordsResearch, field: "Competitor Keywords Research" },
                FourOthers: { state: FourOthers, field: "Other (please specify)", value: FourOthersVal },
            },
            improve: {
                SEOChecker: { state: SEOCheckerImprove, field: "SEO Checker" },
                Sitespeedup: { state: SitespeedupImprove, field: "Site speed up" },
                ImageOptimization: { state: ImageOptimizationImprove, field: "Image Optimization" },
                OnPageSEO: { state: OnPageSEOImprove, field: "On-Page SEO" },
                MetaTags: { state: MetaTagsImprove, field: "Meta Tags" },
                ExchangeBacklink: { state: ExchangeBacklinkImprove, field: "Exchange Backlink" },
                CompetitorKeywordsResearch: { state: CompetitorKeywordsResearchImprove, field: "Competitor Keywords Research" },
                FifthOthers: { state: FifthOthers, field: "Other (please specify)", value: FifthOthersVal },
            },
            encounter: {
                Complex: { state: Complex, field: "Complex functionality, difficult to get started with" },
                DelayedDataUpdates: { state: DelayedDataUpdates, field: "Delayed data updates" },
                UserInterfaceUnfriendly: { state: UserInterfaceUnfriendly, field: "User interface unfriendly" },
                SlowCustomerServiceResponse: { state: SlowCustomerServiceResponse, field: "Slow customer service response" },
                TooExpensive: { state: TooExpensive, field: "Too expensive" },
                SixOthers: { state: SixOthers, field: "Other (please specify)", value: SixOthersVal },
            },
            improveSel: {
                state: true,
                score: improveSel,
                value: improveVal,
                field: 'improveSel'
            },
            describe: { state: true, value: describeVal, field: 'describe' },
        }
        let usedState = usedType === -1;
        let purposeArr = Object.keys(dataObj.purpose).filter(i => dataObj.purpose[i].state);
        let purposeState = purposeArr.length === 0 || (purposeArr.includes('ThirdOthers') && !ThirdOthersVal);
        let valuableArr = Object.keys(dataObj.valuable).filter(i => dataObj.valuable[i].state);
        let valuableState = valuableArr.length === 0 || (valuableArr.includes('FourOthers') && !FourOthersVal);
        let improveArr = Object.keys(dataObj.improve).filter(i => dataObj.improve[i].state);
        let improveState = improveArr.length === 0 || (improveArr.includes('FifthOthers') && !FifthOthersVal);
        let encounterArr = Object.keys(dataObj.encounter).filter(i => dataObj.encounter[i].state);
        let encounterState = encounterArr.length === 0 || (encounterArr.includes('SixOthers') && !SixOthersVal);
        let selectState = improveSel === -1;
        if (!websiteVal || usedState || purposeState || valuableState || improveState || encounterState || selectState || !describeVal) {
            this.setState({
                isShowWarnFeedback: "Please fill in the required fields",
            })
        } else {
            this.setState({
                sendLoading: true,
            }, async () => {
                const params = {
                    flag: 4,
                    title: "SEOAnt-激励反馈",
                    description: JSON.stringify(dataObj)
                }
                const res = await reqReviewTipsClick(params);
                if (res.ack === 1) {
                    this.toggleToast(t("Success"));
                    this.setState({
                        sendLoading: false,
                        isTaskFbLoading: true,
                    }, () => {
                        this.closeFeedback();
                        this.SaveTaskState(1);
                    })
                } else {
                    this.setState({
                        sendLoading: false,
                        isShowWarnFeedback: res.msg,
                    })
                }
            })
        }
    }

    // 选择单选
    handleRadioState = (type) => {
        this.setState({
            usedType: type
        })
    }

    // 关闭任务
    closeTaskModal = () => {
        this.setState({
            isShowModal: false,
        }, () => {
            this.props.closeTaskBlock();
        })
    }

    // 验证
    verifyLink = () => {
        this.setState({
            verifyLoading: true,
        }, () => {
            let platType = ["www.linkedin.com", "x.com", "www.facebook.com"];
            let { verifyUrl, isFinishState } = this.state;
            let verifyState = platType.filter(i => verifyUrl.indexOf(i) > -1);
            if (verifyState.length > 0 && !isFinishState) {
                this.SaveTaskState(2);
            } else {
                this.setState({
                    verifyError: "Verify failed!",
                    verifyLoading: false,
                })
            }
        })
    }

    // 保存任务状态
    SaveTaskState = async (type = 1) => {
        let { verifyUrl } = this.state;
        let params = {
            parent_name: "is_new_user_incentives",
            name: type === 1 ? "feedback" : "share_platform",
            type: `json`,
        }
        if (type === 1) {
            params.json = {
                at: Math.floor((new Date().getTime()) / 1000),
                st: 1
            }
        } else {
            params.json = {
                at: Math.floor((new Date().getTime()) / 1000),
                st: verifyUrl ? 1 : 0,
                postlink: {
                    first: verifyUrl,
                    sec: verifyUrl,
                }
            }
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            this.setState({
                loadingPost: false,
            }, () => {
                let data = cloneDeep(store.getState().public.publicInit.head_data?.switch_data)
                if (typeof data === 'boolean') {
                    data = [];
                }
                if (!Boolean(data?.is_new_user_incentives)) {
                    data.is_new_user_incentives = {
                        [params.name]: {}
                    };
                }
                data.is_new_user_incentives[params.name] = {
                    at: params.json.at,
                    st: params.json.st,
                }
                if (type === 2) {
                    this.setState({
                        isFinishState: true,
                        verifyError: "",
                        isShowPlatFinish: true,
                        verifyLoading: false,
                        isShowSharePlat: true,
                    })
                    data[`is_new_user_incentives`].share_platform.postlink = params.json.postlink;
                } else {
                    this.setState({
                        isTaskFbLoading: false,
                        isFinishFeedbackSet: true,
                        isShowFBFinish: true,
                    }, () => {
                        this.props.setImageQuota();
                    })
                }
                this.props.setSwitchData(data);
            })
        } else {
            this.setState({
                loadingPost: false,
                isTaskFbLoading: false,
                isShowFBFinish: false,
                isShowPlatFinish: false,
                verifyLoading: false,
            })
            this.toggleToast(t("Try again later"), true)
        }
    }

    // 关闭
    closeCongraModal = (type) => {
        this.setState({
            [type]: false
        })
    }

    // 关闭弹窗
    toggleTaskModal = (type, _state) => {
        this.props.toggleTaskType(type, Boolean(_state));
    }

    // 输入链接
    handleVerifyUrlInput = (v) => {
        this.setState({
            verifyUrl: v,
            verifyError: "",
        })
    }

    // 复制
    copyUrlText = (url) => {
        this.toggleToast(t("Copy successfully!"), false);
        utils.CopyText(url);
    }

    //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

    render() {
        const {
            showToast,
            showToastText,
            showToastIserror,
            isShowFeedback,
            isShowWarnFeedback,
            KeywordResearch,
            CompetitorAnalysis,
            WebsiteAudit,
            BacklinkAnalysis,
            RankingTracking,
            ContentOptimization,
            ImpoveWebsiteSpeed,
            ThirdOthers,
            Complex,
            DelayedDataUpdates,
            UserInterfaceUnfriendly,
            SlowCustomerServiceResponse,
            TooExpensive,
            FourOthers,
            websiteVal,
            usedAppVal,
            ThirdOthersVal,
            FourOthersVal,
            SEOChecker,
            Sitespeedup,
            ImageOptimization,
            OnPageSEO,
            MetaTags,
            ExchangeBacklink,
            CompetitorKeywordsResearch,
            SEOCheckerImprove,
            SitespeedupImprove,
            ImageOptimizationImprove,
            OnPageSEOImprove,
            MetaTagsImprove,
            ExchangeBacklinkImprove,
            CompetitorKeywordsResearchImprove,
            FifthOthers,
            FifthOthersVal,
            SixOthers,
            SixOthersVal,
            improveVal,
            improveSel,
            sendLoading,
            usedType,
            describeVal,
            isShowFBFinish,
            curImage,
            // isShowPlatFinish,
            // curAi,
            ap_login_url,
            short_url,
            isShowSharePlat,
            verifyUrl,
            isFinishState,
            verifyError,
            verifyLoading,
        } = this.state;

        // 消息提示弹窗
        const toastMarkup = showToast ? <ToastFunc content={showToastText} onDismiss={showToast} error={showToastIserror} /> : null;

        // 反馈弹窗
        const FeedbackModal = <Modal
            open={isShowFeedback}
            title={t("It will only take you 2 minutes")}
            primaryAction={{
                content: t("Save"),
                loading: sendLoading,
                onAction: this.saveFeedback
            }}
            onClose={this.closeFeedback}
        >
            <div className="task_feedback">
                <BlockStack gap={400}>
                    {
                        isShowWarnFeedback && <Banner
                            tone="warning"
                            title={t(isShowWarnFeedback)}
                            onDismiss={() => {
                                this.setState({ isShowWarnFeedback: false })
                            }}
                        ></Banner>
                    }
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>1. {t("What industry is your website in")} :</p>
                        <Select
                            id="websiteVal"
                            label=""
                            options={[
                                { label: t("Fashion & Apparel"), value: 'Fashion & Apparel' },
                                { label: t("Health & Beauty"), value: 'Health & Beauty' },
                                { label: t("Home & Furniture"), value: 'Home & Furniture' },
                                { label: t("Food & Beverage"), value: 'Food & Beverage' },
                                { label: t("Electronics"), value: 'Electronics' },
                                { label: t("Sports & Outdoors"), value: 'Sports & Outdoors' },
                                { label: t("Toys & Games"), value: 'Toys & Games' },
                                { label: t("Arts & Crafts"), value: 'Arts & Crafts' },
                                { label: t("Automotive & Motorcycles"), value: 'Automotive & Motorcycles' },
                                { label: t("Pet Supplies"), value: 'Pet Supplies' },
                                { label: t("Books & Stationery"), value: 'Books & Stationery' },
                                { label: t("Others"), value: 'Others' },
                            ]}
                            placeholder=" "
                            onChange={this.handleChangeValue}
                            value={websiteVal}
                        />
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>2. {t("Have you used SEO products before?")}</p>
                        <RadioButton
                            id={"usedYes"}
                            label={t("Yes")}
                            checked={usedType === 1}
                            name={t("Yes")}
                            onChange={() => this.handleRadioState(1)}
                        />
                        <RadioButton
                            id={"usedNo"}
                            label={t("No")}
                            checked={usedType === 2}
                            name={t("No")}
                            onChange={() => this.handleRadioState(2)}
                        />
                        {
                            usedType === 1 &&
                            <TextField
                                multiline={1}
                                id="usedAppVal"
                                value={usedAppVal}
                                placeholder={t("Please enter the SEO product you have used before")}
                                onChange={this.handleChangeValue}
                            />
                        }
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>3. {t("What is the main purpose of using SEO software? (Multiple options available)")} :</p>
                        <Checkbox
                            label={t("Keyword research")}
                            id="KeywordResearch"
                            checked={KeywordResearch}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Competitor analysis")}
                            id="CompetitorAnalysis"
                            checked={CompetitorAnalysis}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Website Audit")}
                            id="WebsiteAudit"
                            checked={WebsiteAudit}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Backlink analysis")}
                            id="BacklinkAnalysis"
                            checked={BacklinkAnalysis}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Ranking tracking")}
                            id="RankingTracking"
                            checked={RankingTracking}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Content optimization")}
                            id="ContentOptimization"
                            checked={ContentOptimization}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Impove website speed")}
                            id="ImpoveWebsiteSpeed"
                            checked={ImpoveWebsiteSpeed}
                            onChange={this.handleChangeValue}
                        />
                        <div className="other_input">
                            <Checkbox
                                label={t("Others (please specify)")}
                                id="ThirdOthers"
                                checked={ThirdOthers}
                                onChange={this.handleChangeValue}
                            />
                            {
                                ThirdOthers && <TextField
                                    multiline={1}
                                    id="ThirdOthersVal"
                                    value={ThirdOthersVal}
                                    onChange={this.handleChangeValue}
                                />
                            }
                        </div>
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>4. {t("What do you think is the most valuable feature of SEO software? Why?")}</p>
                        <Checkbox
                            label={t("SEO Checker")}
                            id="SEOChecker"
                            checked={SEOChecker}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Site speed up")}
                            id="Sitespeedup"
                            checked={Sitespeedup}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Image Optimization")}
                            id="ImageOptimization"
                            checked={ImageOptimization}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("On-Page SEO")}
                            id="OnPageSEO"
                            checked={OnPageSEO}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Meta Tags")}
                            id="MetaTags"
                            checked={MetaTags}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Exchange Backlink")}
                            id="ExchangeBacklink"
                            checked={ExchangeBacklink}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Competitor Keywords Research")}
                            id="CompetitorKeywordsResearch"
                            checked={CompetitorKeywordsResearch}
                            onChange={this.handleChangeValue}
                        />
                        <div className="other_input">
                            <Checkbox
                                label={t("Others (please specify)")}
                                id="FourOthers"
                                checked={FourOthers}
                                onChange={this.handleChangeValue}
                            />
                            {
                                FourOthers && <TextField
                                    multiline={1}
                                    id="FourOthersVal"
                                    value={FourOthersVal}
                                    onChange={this.handleChangeValue}
                                />
                            }
                        </div>
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>5. {t("What functions or aspects do you think need improvement? Please provide specific instructions.")} :</p>
                        <Checkbox
                            label={t("SEO Checker")}
                            id="SEOCheckerImprove"
                            checked={SEOCheckerImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Site speed up")}
                            id="SitespeedupImprove"
                            checked={SitespeedupImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Image Optimization")}
                            id="ImageOptimizationImprove"
                            checked={ImageOptimizationImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("On-Page SEO")}
                            id="OnPageSEOImprove"
                            checked={OnPageSEOImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Meta Tags")}
                            id="MetaTagsImprove"
                            checked={MetaTagsImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Exchange Backlink")}
                            id="ExchangeBacklinkImprove"
                            checked={ExchangeBacklinkImprove}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Competitor Keywords Research")}
                            id="CompetitorKeywordsResearchImprove"
                            checked={CompetitorKeywordsResearchImprove}
                            onChange={this.handleChangeValue}
                        />
                        <div className="other_input">
                            <Checkbox
                                label={t("Others (please specify)")}
                                id="FifthOthers"
                                checked={FifthOthers}
                                onChange={this.handleChangeValue}
                            />
                            {
                                FifthOthers && <TextField
                                    multiline={1}
                                    id="FifthOthersVal"
                                    value={FifthOthersVal}
                                    onChange={this.handleChangeValue}
                                />
                            }
                        </div>
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>6. {t("What are the most common problems you encounter during use SEOAnt? (Multiple options available)")} :</p>
                        <Checkbox
                            label={t("Complex functionality, difficult to get started with")}
                            id="Complex"
                            checked={Complex}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Delayed data updates")}
                            id="DelayedDataUpdates"
                            checked={DelayedDataUpdates}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("User interface unfriendly")}
                            id="UserInterfaceUnfriendly"
                            checked={UserInterfaceUnfriendly}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Slow customer service response")}
                            id="SlowCustomerServiceResponse"
                            checked={SlowCustomerServiceResponse}
                            onChange={this.handleChangeValue}
                        />
                        <Checkbox
                            label={t("Too expensive")}
                            id="TooExpensive"
                            checked={TooExpensive}
                            onChange={this.handleChangeValue}
                        />
                        <div className="other_input">
                            <Checkbox
                                label={t("Others (please specify)")}
                                id="SixOthers"
                                checked={SixOthers}
                                onChange={this.handleChangeValue}
                            />
                            {
                                SixOthers && <TextField
                                    multiline={1}
                                    id="SixOthersVal"
                                    value={SixOthersVal}
                                    onChange={this.handleChangeValue}
                                />
                            }
                        </div>
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>7. {t("Based on your experience with this app, how likely are you to recommend it to a friend or colleague? (0 means not at all likely, 10 means extremely likely)")}</p>
                        <BlockStack gap={200}>
                            <Select
                                id="improveSel"
                                label=""
                                options={[
                                    { label: '10', value: '10' },
                                    { label: '9', value: '9' },
                                    { label: '8', value: '8' },
                                    { label: '7', value: '7' },
                                    { label: '6', value: '6' },
                                    { label: '5', value: '5' },
                                    { label: '4', value: '4' },
                                    { label: '3', value: '3' },
                                    { label: '2', value: '2' },
                                    { label: '1', value: '1' },
                                    { label: '0', value: '0' },
                                ]}
                                placeholder=" "
                                onChange={this.handleChangeValue}
                                value={improveSel}
                            />
                            {
                                improveSel !== "" &&
                                <TextField
                                    multiline={1}
                                    id="improveVal"
                                    value={improveVal}
                                    placeholder={t("Please state your reasons for being willing/unwilling to recommend")}
                                    onChange={this.handleChangeValue}
                                />
                            }
                        </BlockStack>
                    </div>
                    <div className="task_fb_item">
                        <p><span className="t_grade">* </span>8. {t("If you were to recommend SEOAnt to others, how would you describe SEOAnt?")}</p>
                        <TextField
                            multiline={1}
                            id="describeVal"
                            value={describeVal}
                            onChange={this.handleChangeValue}
                        />
                    </div>
                    <p>{t("Thank you for your answer. We will update the product carefully based on your suggestions!")}</p>
                </BlockStack>
            </div>
        </Modal>

        // 平台icon
        const inIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M1.41017 3.85843C0.799805 5.05634 0.799805 6.62449 0.799805 9.76078V14.2408C0.799805 17.3771 0.799805 18.9452 1.41017 20.1431C1.94706 21.1968 2.80375 22.0535 3.85746 22.5904C5.05536 23.2008 6.62351 23.2008 9.7598 23.2008H14.2398C17.3761 23.2008 18.9442 23.2008 20.1422 22.5904C21.1959 22.0535 22.0526 21.1968 22.5894 20.1431C23.1998 18.9452 23.1998 17.3771 23.1998 14.2408V9.76078C23.1998 6.62449 23.1998 5.05634 22.5894 3.85843C22.0526 2.80473 21.1959 1.94804 20.1422 1.41114C18.9442 0.800781 17.3761 0.800781 14.2398 0.800781H9.75981C6.62351 0.800781 5.05536 0.800781 3.85746 1.41114C2.80375 1.94804 1.94706 2.80473 1.41017 3.85843ZM6.39844 9.1982H8.63777V17.5957H6.39844V9.1982ZM7.51138 8.07854H7.49907C6.83063 8.07854 6.39844 7.58029 6.39844 6.95831C6.39844 6.3229 6.84406 5.83921 7.52426 5.83921C8.20558 5.83921 8.62489 6.3229 8.63777 6.95831C8.63777 7.58029 8.20558 8.07854 7.51138 8.07854ZM18.1549 12.2773C18.1549 10.5765 16.7766 9.1982 15.0758 9.1982C14.0334 9.1982 13.1136 9.71773 12.5566 10.5104V9.1982H10.3173V17.5957H12.5566V13.117C12.5566 12.1894 13.3084 11.4375 14.2361 11.4375C15.1637 11.4375 15.9156 12.1894 15.9156 13.117V17.5957H18.1549V12.2773Z" fill="#4A4A4A" />
        </svg>
        const fbIcon = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.41017 3.85843C0.799805 5.05634 0.799805 6.62449 0.799805 9.76078V14.2408C0.799805 17.3771 0.799805 18.9452 1.41017 20.1431C1.94706 21.1968 2.80375 22.0535 3.85746 22.5904C5.05536 23.2008 6.62351 23.2008 9.7598 23.2008H10.2936V15.2382H7.44981V11.9445H10.2936V9.43405C10.2936 6.57825 11.9656 5.00078 14.524 5.00078C15.7494 5.00078 17.0311 5.22333 17.0311 5.22333V8.0275H15.6187C14.2274 8.0275 13.7936 8.90587 13.7936 9.80699V11.9445H16.8999L16.4033 15.2382H13.7936V23.2008H14.2398C17.3761 23.2008 18.9442 23.2008 20.1422 22.5904C21.1959 22.0535 22.0526 21.1968 22.5894 20.1431C23.1998 18.9452 23.1998 17.3771 23.1998 14.2408V9.76078C23.1998 6.62449 23.1998 5.05634 22.5894 3.85843C22.0526 2.80473 21.1959 1.94804 20.1422 1.41114C18.9442 0.800781 17.3761 0.800781 14.2398 0.800781H9.75981C6.62351 0.800781 5.05536 0.800781 3.85746 1.41114C2.80375 1.94804 1.94706 2.80473 1.41017 3.85843Z" fill="#4A4A4A" />
        </svg>
        const xIcon = <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="22" height="22" rx="8" fill="#4A4A4A" />
            <path d="M15.1546 5H17.3266L12.5819 10.1423L18.1633 17.14H13.7929L10.3694 12.896L6.45328 17.14H4.27922L9.35474 11.6395L4 5H8.48168L11.5754 8.87872L15.1546 5ZM14.3918 15.9078H15.5957L7.82712 6.16746H6.53624L14.3918 15.9078Z" fill="white" />
        </svg>

        // 分享弹窗
        const SharePlatModal = <Modal
            open={isShowSharePlat}
            title={t("Share 30% off with your friends")}
            secondaryActions={[
                {
                    content: t("Close"),
                    onAction: () => this.toggleTaskModal("isShowSharePlat", false)
                }
            ]}
            onClose={() => this.toggleTaskModal("isShowSharePlat", false)}
        >
            <Modal.Section>
                <div className="share_block">
                    <BlockStack gap={400}>
                        <BlockStack gap={200}>
                            <Text variant="bodyMd" as="p">{t("Share SEOAnt to earn 30% commission of every payment")},&nbsp;<Button variant="plain" onClick={() => {
                                window.open(ap_login_url)
                            }}>{t("your affiliate account")}</Button></Text>
                            <div className="share_url flex_layout">
                                <div className="share_info">
                                    <TextField
                                        value={short_url}
                                        suffix={<span onClick={() => this.copyUrlText(short_url)}><Icon source={DuplicateMinor} tone="base" /></span>}
                                    />
                                </div>
                                <div className="share_plat">
                                    <Tooltip content={t("LinkedIn")}><span onClick={() => this.openAppAction('linkin')}>{inIcon}</span></Tooltip>
                                    <Tooltip content={t("Facebook")}><span onClick={() => this.openAppAction('facebook')}>{fbIcon}</span></Tooltip>
                                    <Tooltip content={t("Twitter")}><span onClick={() => this.openAppAction('tw')}>{xIcon}</span></Tooltip>
                                </div>
                            </div>
                        </BlockStack>
                        <BlockStack gap={200}>
                            <Text variant="bodyMd" as="p">{t("Verify your shared link to get {{v1}} AI credits", 20)}</Text>
                            <div className="share_verify flex_layout">
                                <TextField
                                    disabled={isFinishState}
                                    value={verifyUrl}
                                    placeholder={t("The link you shared just now")}
                                    onChange={this.handleVerifyUrlInput}
                                    prefix={<span><Icon source={LinkMinor} tone="base" /></span>}
                                    error={t(verifyError)}
                                    connectedRight={<Button disabled={!Boolean(verifyUrl) || isFinishState} loading={verifyLoading} onClick={() => this.verifyLink()}>{t("Verify")}</Button>}
                                />
                            </div>
                            {
                                isFinishState && <Banner
                                    title={t("You’ve earned {{v1}} AI Credits", 20) + " 🎉"}
                                    tone="success"
                                />
                            }
                        </BlockStack>
                    </BlockStack>
                </div>
            </Modal.Section>
        </Modal>

        // 钱包图标
        const walletIcon = <svg width="36" height="27" viewBox="0 0 36 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.3944 7.24805H3.13485C2.35958 7.24805 1.61605 7.55602 1.06785 8.10423C0.519647 8.65243 0.21167 9.39595 0.21167 10.1712V23.4584C0.21167 24.2337 0.519647 24.9772 1.06785 25.5254C1.61605 26.0736 2.35958 26.3816 3.13485 26.3816H24.3944C25.1696 26.3816 25.9132 26.0736 26.4614 25.5254C27.0096 24.9772 27.3176 24.2337 27.3176 23.4584V10.1712C27.3176 9.39595 27.0096 8.65243 26.4614 8.10423C25.9132 7.55602 25.1696 7.24805 24.3944 7.24805ZM3.13485 8.84251H24.3944C24.7468 8.84251 25.0847 8.9825 25.3339 9.23168C25.5831 9.48087 25.7231 9.81883 25.7231 10.1712V23.4584C25.7231 23.8108 25.5831 24.1488 25.3339 24.398C25.0847 24.6472 24.7468 24.7871 24.3944 24.7871H3.13485C2.78245 24.7871 2.44449 24.6472 2.19531 24.398C1.94612 24.1488 1.80613 23.8108 1.80613 23.4584V10.1712C1.80613 9.81883 1.94612 9.48087 2.19531 9.23168C2.44449 8.9825 2.78245 8.84251 3.13485 8.84251Z" fill="#303030" />
            <path d="M19.6294 12.2515C19.4812 12.1102 19.2844 12.0314 19.0796 12.0312H5.5267L5.45016 12.035C5.24638 12.0547 5.05801 12.1521 4.92408 12.307C4.79016 12.4618 4.72094 12.6623 4.73078 12.8668C4.74062 13.0713 4.82876 13.2642 4.97693 13.4055C5.12511 13.5467 5.32196 13.6256 5.5267 13.6257H19.0796L19.1562 13.622C19.36 13.6022 19.5483 13.5048 19.6822 13.35C19.8162 13.1951 19.8854 12.9947 19.8756 12.7902C19.8657 12.5857 19.7776 12.3928 19.6294 12.2515Z" fill="#7126EF" />
            <path d="M22.8606 22.4346C22.8205 22.3379 22.7999 22.2342 22.7999 22.1295C22.7999 22.0248 22.8205 21.9211 22.8606 21.8244C22.9007 21.7277 22.9594 21.6398 23.0334 21.5658C23.1074 21.4917 23.1953 21.433 23.2921 21.393C23.3888 21.3529 23.4925 21.3323 23.5971 21.3323C23.7018 21.3323 23.8055 21.3529 23.9022 21.393C23.999 21.433 24.0868 21.4917 24.1609 21.5658C24.2349 21.6398 24.2936 21.7277 24.3337 21.8244C24.3738 21.9211 24.3944 22.0248 24.3944 22.1295C24.3944 22.2342 24.3738 22.3379 24.3337 22.4346C24.2936 22.5313 24.2349 22.6192 24.1609 22.6932C24.0868 22.7673 23.999 22.826 23.9022 22.8661C23.8055 22.9061 23.7018 22.9267 23.5971 22.9267C23.4925 22.9267 23.3888 22.9061 23.2921 22.8661C23.1953 22.826 23.1074 22.7673 23.0334 22.6932C22.9594 22.6192 22.9007 22.5313 22.8606 22.4346Z" fill="#7126EF" />
            <path d="M20.1425 22.1295C20.1425 22.3409 20.2265 22.5437 20.376 22.6932C20.5255 22.8427 20.7283 22.9267 20.9397 22.9267C21.1512 22.9267 21.354 22.8427 21.5035 22.6932C21.653 22.5437 21.737 22.3409 21.737 22.1295C21.737 21.9181 21.653 21.7153 21.5035 21.5658C21.354 21.4163 21.1512 21.3323 20.9397 21.3323C20.7283 21.3323 20.5255 21.4163 20.376 21.5658C20.2265 21.7153 20.1425 21.9181 20.1425 22.1295Z" fill="#7126EF" />
            <path d="M17.1871 22.6932C17.0376 22.5437 16.9536 22.3409 16.9536 22.1295C16.9536 21.9181 17.0376 21.7153 17.1871 21.5658C17.3366 21.4163 17.5394 21.3323 17.7509 21.3323C17.9623 21.3323 18.1651 21.4163 18.3146 21.5658C18.4641 21.7153 18.5481 21.9181 18.5481 22.1295C18.5481 22.3409 18.4641 22.5437 18.3146 22.6932C18.1651 22.8427 17.9623 22.9267 17.7509 22.9267C17.5394 22.9267 17.3366 22.8427 17.1871 22.6932Z" fill="#7126EF" />
            <path d="M21.1651 6.6541C21.7567 6.81185 22.2835 7.15198 22.6708 7.62619L22.7569 7.73674L21.476 8.68545C21.3183 8.47184 21.0997 8.31085 20.8489 8.22359L20.7527 8.19382L6.89148 4.47979C6.56573 4.3925 6.21897 4.43234 5.92151 4.59124C5.62405 4.75013 5.39814 5.01619 5.28957 5.33548L5.26406 5.41946L4.5051 8.25282L2.96484 7.84038L3.72381 5.00702C3.91909 4.27765 4.38902 3.65213 5.03518 3.26148C5.68133 2.87084 6.45358 2.74537 7.19017 2.91137L7.30391 2.93953L21.1651 6.6541Z" fill="#303030" />
            <path d="M21.6371 3.38922C22.3662 3.58461 22.9915 4.05451 23.382 4.70053C23.7726 5.34655 23.898 6.11861 23.7322 6.85505L23.704 6.96932L23.3708 8.21194L21.8305 7.7995L22.1638 6.55688C22.2512 6.23106 22.2114 5.88418 22.0525 5.58659C21.8936 5.28901 21.6275 5.06302 21.3081 4.95445L21.2241 4.92947L11.4702 2.31561C11.1444 2.22817 10.7975 2.26794 10.4999 2.42684C10.2023 2.58575 9.97635 2.8519 9.86778 3.17131L9.8428 3.25528L9.58025 4.23322L8.04053 3.82079L8.30255 2.84285C8.49783 2.11359 8.96768 1.48816 9.61372 1.09752C10.2598 0.706891 11.0319 0.58135 11.7684 0.74719L11.8827 0.77536L21.6371 3.38922Z" fill="#303030" />
            <path fillRule="evenodd" clipRule="evenodd" d="M29.647 17.2059C33.1556 17.2059 36 14.3616 36 10.8529C36 7.34431 33.1556 4.5 29.647 4.5C26.1384 4.5 23.2941 7.34431 23.2941 10.8529C23.2941 12.5407 23.9523 14.0748 25.026 15.2125L23.5795 16.2457C23.1604 16.545 23.3722 17.2059 23.8873 17.2059H29.642C29.6437 17.2059 29.6453 17.2059 29.647 17.2059Z" fill="#33CE87" />
            <path d="M27.5294 10.7539L29.0962 12.3207L32.1719 9.24505" stroke="white" strokeWidth="1.58824" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

        // 完成反馈额度弹窗
        const fbShowModal = <Modal
            open={isShowFBFinish}
            title={t("Congratulations!")}
            primaryAction={{
                content: t("OK"),
                onAction: () => this.closeCongraModal('isShowFBFinish')
            }}
            onClose={() => this.closeCongraModal('isShowFBFinish')}
        >
            <div className="congra_main">
                <p>
                    {walletIcon}
                    <span>{t("Congratulations! Your image compression quota has been increased")}</span>
                </p>
                <p className="congra_quota">
                    <span>{t("Current Image Quota")}: </span>
                    <span>
                        <CountUp start={curImage} end={curImage + 200} delay={1} decimals="0" duration={0.5} />
                    </span>
                </p>
            </div>
        </Modal>

        // 完成平台额度弹窗
        // const platShowModal = <Modal
        //     open={isShowPlatFinish}
        //     title={t("Congratulations!")}
        //     primaryAction={{
        //         content: t("OK"),
        //         onAction: () => this.closeCongraModal('isShowPlatFinish')
        //     }}
        //     onClose={() => this.closeCongraModal('isShowPlatFinish')}
        // >
        //     <div className="congra_main">
        //         <p>
        //             {walletIcon}
        //             <span>{t("Congratulations! Your AI credits has been increased!")}</span>
        //         </p>
        //         <p className="congra_quota">
        //             <span>{t("Current AI credits")}: </span>
        //             <span>
        //                 <CountUp start={curAi} end={curAi + 20} delay={1} decimals="0" duration={0.5} />
        //             </span>
        //         </p>
        //     </div>
        // </Modal>

        return (
            <div className="task_container">
                {FeedbackModal}
                {SharePlatModal}
                {fbShowModal}
                {/* {platShowModal} */}
                {toastMarkup}
            </div>

        );
    }
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },

})

TaskReward = connect(
    mapStateToProps,
    mapDispatchToProps
)(TaskReward);

export default withRouter(TaskReward);